module.exports = __webpack_public_path__ + "img/box8-2.f246b6ca.png";